import React from "react";
import PropTypes from "prop-types";

import CardHeader from "../ContentElements/CardHeader/CardHeader";
import { CardListItem } from "../ContentElements/CardListItem/CardListItem";
import styles from "./HelpTopics.module.css";

import iconsMap from "../../../assets/iconsMap.js";

const HelpTopics = ({ data = {} }) => {
  const { elements = [] } = data;

  if (!elements.length) {
    return null;
  }

  const LiItems = elements.filter((item) => item.type === "topic");
  const header = elements.filter((item) => item.type === "header")[0];

  return (
    <>
      {header && (
        <CardHeader
          text={header.text}
          isCaps={header.isCaps}
          styles={styles}
          id="topics"
        />
      )}
      <ul className={styles.topicList}>
        {LiItems &&
          LiItems.map((item, i) => (
            <CardListItem
              key={`${item.text}-${i}`}
              text={item.text}
              icon={iconsMap(item.iconId && item.iconId.text)}
              link={item.link && item.link.link && item.link.link.href}
            />
          ))}
      </ul>
    </>
  );
};

export default HelpTopics;

HelpTopics.propTypes = {
  data: PropTypes.shape({
    elements: PropTypes.array,
  }),
};
